import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Copy, Send, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DraftBox = ({ m, token }) => {
  const [text, setText] = useState(m.draft || "");
  const [busy, setBusy] = useState(false);

  const generate = async () => {
    setBusy(true);
    setText("");
    try {
      const res = await fetch(`${API}/admin/messages/${m.id}/draft`, { method: "POST", headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok || !res.body) throw new Error();
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        setText((t) => t + dec.decode(value, { stream: true }));
      }
    } catch {
      toast.error("No se pudo generar el borrador");
    } finally {
      setBusy(false);
    }
  };

  const copy = () => { navigator.clipboard?.writeText(text); toast.success("Copiado"); };
  const subject = encodeURIComponent("Re: tu mensaje — Camila Eterovic");

  return (
    <div className="mt-6 border-t border-white/10 pt-5">
      <button data-testid={`inbox-draft-btn-${m.id}`} onClick={generate} disabled={busy} className="flex items-center gap-2 rounded-full border border-[var(--acid)] px-4 py-2 text-sm text-[var(--acid)] transition-colors hover:bg-[var(--acid)] hover:text-[var(--ink)] disabled:opacity-60">
        {busy ? <Loader2 size={15} className="animate-spin" /> : <Sparkles size={15} />}
        {text ? "Rehacer borrador con IA" : "Redactar respuesta con IA"}
      </button>
      {text && (
        <>
          <textarea data-testid={`inbox-draft-text-${m.id}`} value={text} onChange={(e) => setText(e.target.value)} rows={8} className="mt-4 w-full resize-y rounded-2xl border border-white/10 bg-black/40 p-4 text-zinc-100 outline-none focus:border-[var(--acid)]" />
          <div className="mt-3 flex flex-wrap gap-3">
            <button data-testid={`inbox-draft-copy-${m.id}`} onClick={copy} className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm hover:bg-white/10"><Copy size={14} />Copiar</button>
            <a data-testid={`inbox-draft-mailto-${m.id}`} href={`mailto:${m.email}?subject=${subject}&body=${encodeURIComponent(text)}`} className="flex items-center gap-2 rounded-full bg-[var(--acid)] px-4 py-2 text-sm font-semibold text-[var(--ink)]"><Send size={14} />Abrir en mi email</a>
          </div>
        </>
      )}
    </div>
  );
};
